import { LitElement, html, css, utils, styles } from '@hh/global.js'

const { getCart, updateCart } = utils

class HHCartProof extends LitElement {
  constructor() {
    super()

    this.proofInputs = this.querySelectorAll('.js-proof-input')
  }

  connectedCallback() {
    super.connectedCallback()

    this.checkCartProof()
    this.proofInputs.forEach((input) =>
      input.addEventListener('input', this.handleProofChange.bind(this))
    )
  }

  disconnectedCallback() {
    super.disconnectedCallback()
    this.proofInputs.forEach((input) =>
      input.removeEventListener('input', this.handleProofChange)
    )
  }

  async handleProofChange(e) {
    const { value: proofStatus } = e.target

    await updateCart({
      attributes: {
        _proof: proofStatus,
      },
    })
  }

  async checkCartProof() {
    const cart = await getCart()
    const cartProofAvailable = cart.items.some(
      (item) =>
        item?.properties?._customization_method === 'full' ||
        item?.properties?._customizer_version
    )

    if (!cartProofAvailable) {
      this.setAttribute('hidden', true)

      await updateCart({
        attributes: {
          _proof: '',
        },
      })
    } else {
      this.removeAttribute('hidden')
    }
  }

  render() {
    return html` <slot @toggle="${this.showEstimator}"></slot> `
  }

  static styles = [styles.visuallyHidden, css``]
}

customElements.define('hh-cart-proof', HHCartProof)
